import { render, staticRenderFns } from "./AddTerms.vue?vue&type=template&id=31f3059f"
import script from "./AddTerms.vue?vue&type=script&lang=js"
export * from "./AddTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports